var _circle, _g, _path, _rect, _rect2, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 434,
    viewBox: "0 0 434 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 217,
    r: 217,
    fill: "#CEEED7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5416_18079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354 306H359V301V131C359 122.716 352.284 116 344 116H90C81.7157 116 75 122.716 75 131V301V306H80H354Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 300,
    width: 327,
    height: 13,
    rx: 6,
    fill: "#102D3E",
    stroke: "#102D3E",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354 305H358V301V131C358 123.268 351.732 117 344 117H90C82.268 117 76 123.268 76 131V301V305H80H354Z",
    fill: "#E4D7D2",
    stroke: "#FAB39D",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 301,
    width: 325,
    height: 11,
    rx: 5,
    fill: "#FAB39D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 138,
    width: 222,
    height: 146,
    rx: 5,
    fill: "#F7ECE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.199 208.463C247.065 210.253 247.065 215.748 243.199 217.538L206.101 234.713C202.787 236.247 199 233.827 199 230.175L199 195.825C199 192.173 202.787 189.753 206.101 191.287L243.199 208.463Z",
    fill: "#0999B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M321.222 239.29H320.882L320.613 239.497L319.45 240.39L319.444 240.395L319.437 240.4C308.826 248.824 296.318 253.766 282.881 254.857C287.141 249.26 290.648 243.093 293.267 236.557L293.271 236.548L294.522 233.334L294.806 232.607L294.169 232.155L291.397 230.192L291.39 230.187C278.067 220.913 270 205.51 270 189.145C270 178.994 273.068 169.105 278.855 160.703L278.855 160.703L278.858 160.698C280.516 158.26 282.53 155.899 284.729 153.703C294.2 144.25 306.823 139 320.238 139H359.762C387.468 139 410 161.493 410 189.145C410 202.535 404.742 215.134 395.271 224.587C385.799 234.041 373.266 239.29 359.762 239.29H321.222Z",
    fill: "#F7ECE8",
    stroke: "#102D3E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.778 179.29H131.118L131.387 179.497L132.55 180.39L132.556 180.395L132.563 180.4C143.174 188.824 155.682 193.766 169.119 194.857C164.859 189.26 161.352 183.093 158.733 176.557L158.729 176.548L157.478 173.334L157.194 172.607L157.831 172.155L160.603 170.192L160.61 170.187C173.933 160.913 182 145.51 182 129.145C182 118.994 178.932 109.105 173.145 100.703L173.145 100.703L173.142 100.698C171.484 98.2604 169.47 95.8985 167.271 93.7032C157.8 84.2497 145.177 79 131.762 79H92.238C64.5317 79 42 101.493 42 129.145C42 142.535 47.2585 155.134 56.7291 164.587C66.2005 174.041 78.7342 179.29 92.238 179.29H130.778Z",
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5416_18079",
    x: 53,
    y: 111,
    width: 339,
    height: 215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.178196 0 0 0 0 0.243137 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5416_18079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5416_18079",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/Expert.c92a3eb4939a5b590db9a73c15c4406e.svg";
export { ForwardRef as ReactComponent };